import { render, staticRenderFns } from "./ModalSuccessMessage.vue?vue&type=template&id=08c2f06a&scoped=true&"
import script from "./ModalSuccessMessage.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c2f06a",
  null
  
)

export default component.exports